import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getStripeTransactions = async (queryParams?: string) => {
  try {
    const suffix = queryParams ? `?${queryParams}` : "";
    const res = await get<ApiResponse<any>>(
      `/stripepayments/transaction${suffix}`,
    );
    if (res?.success === true) return res;
    return null;
  } catch (e) {
    HandleApiError(e);
  }
};

